// Inline Right-to-Work actions on cast-list / daily-list RtW tabs.
// Refreshes the .col-rtw cells in a row in place after an action,
// preserving column order (insert before first existing col-rtw, then remove old).

$(function() {
  function replaceCells($row, html) {
    var $existing = $row.find("td.col-rtw");
    if ($existing.length === 0) return;
    var $new = $("<tbody><tr>" + html + "</tr></tbody>").find("td");
    $existing.first().before($new);
    $existing.remove();
  }

  // Delegate from body so this works across cast list + daily list + any future RtW tab surface
  var $body = $("body");

  // Links inside .js-rtw-inline are plain anchors; we POST via $.post below.
  // Not using Rails UJS here (would double-submit alongside this handler).
  $body.on("click", ".js-rtw-tab .js-rtw-inline a", function(e) {
    e.preventDefault();
    var $row = $(this).closest("tr");
    $.post(this.href, function(response) {
      replaceCells($row, response);
    }).fail(function(xhr) {
      if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
        alert(xhr.responseJSON.errors.join("\n"));
      }
    });
  });

  $body.on("click", ".js-rtw-tab .js-rtw-upload", function(e) {
    e.preventDefault();
    var $btn = $(this);
    var $row = $btn.closest("tr");
    var $modal = $(".js-rtw-upload-modal");

    $modal.find(".js-rtw-upload-production").val($btn.data("production") || "");
    $modal.data("extra-id", $btn.data("extra"));
    $modal.data("row", $row);
    $modal.modal("show");
  });

  $body.on("click", ".js-rtw-upload-modal .js-rtw-upload-submit", function() {
    var $modal = $(this).closest(".js-rtw-upload-modal");
    var extraId = $modal.data("extra-id");
    var $row = $modal.data("row");
    var form = $modal.find(".js-rtw-upload-form")[0];
    var fd = new FormData(form);
    $.ajax({
      url: "/admin/extras/" + extraId + "/documents",
      method: "POST",
      data: fd,
      contentType: false,
      processData: false,
      success: function(response) {
        replaceCells($row, response);
        $modal.modal("hide");
        form.reset();
      },
      error: function(xhr) {
        alert("Upload failed: " + (xhr.responseText || xhr.statusText));
      }
    });
  });
});
